import {dashboardChartColors} from '../../../../../../util/uiconstants';
import {labels as utilLabels} from '../../../../../../util/utils';

import {config as barchartColumnConfig} from '../../common/BarchartColumn';

const prop = 'status';

export const config = (labels) =>
	barchartColumnConfig({
		id: 'byPriority',
		label: labels.byPriority,
		prop,
		getSeries: (item) => [
			{
				name: utilLabels.critical,
				data: [item.rNOCrit],
				color: dashboardChartColors.orange[3]
			},
			{
				name: utilLabels.high,
				data: [item.rNOHigh],
				color: dashboardChartColors.orange[2]
			},
			{
				name: utilLabels.medium,
				data: [item.rNOMed],
				color: dashboardChartColors.orange[1]
			},
			{
				name: utilLabels.low,
				data: [item.rNOLow],
				color: dashboardChartColors.orange[0]
			}
		],
		customHeaderTooltip: utilLabels.notesTableTooltipContent
	});
